import { createContext } from 'react';

export type ThemeMode = 'light' | 'dark';

export interface ThemeColors {
  background: string;
  surface: string;
  text: string;
  textSecondary: string;
  border: string;
  navBackground: string;
  cardBackground: string;
}

interface ThemeContextType {
  mode: ThemeMode;
  toggleTheme: () => void;
  colors: ThemeColors;
}

// Light theme colors
export const lightColors: ThemeColors = {
  background: '#FFFFFF',
  surface: '#FFFFFF',
  text: '#2F2F2F',
  textSecondary: 'rgba(47, 47, 47, 0.6)',
  border: 'rgba(47, 47, 47, 0.08)',
  navBackground: '#FFFFFF',
  cardBackground: '#FFFFFF',
};

// Dark theme colors
export const darkColors: ThemeColors = {
  background: '#1A1A1A',
  surface: '#242424',
  text: '#F5F5F5',
  textSecondary: 'rgba(245, 245, 245, 0.6)',
  border: 'rgba(255, 255, 255, 0.1)',
  navBackground: '#1A1A1A',
  cardBackground: '#2A2A2A',
};

const ThemeContext = createContext<ThemeContextType>({
  mode: 'light',
  toggleTheme: () => {},
  colors: lightColors,
});

export default ThemeContext;
